import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'verifier_body_name_country_programme'

export const dataPointDefinition = {
  retracedId: 'verifier_body_name_country_programme',
  name: 'Verifier Body Name/ Country Programme:',
  description: '',
  meta: {
    slcpMeta: {
      key: 'vd-e12',
      number: 'VD-VERI-8',
      dataType: 'string',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: '',
      verificationSelectionOptList: '',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '',
      machineShowHide: '',
      completionCondition: '',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'vd-e12', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34630,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
